import {
  COLUMNS,
  FOOTER_HEIGHT,
  HEADER_HEIGHT,
  ROW_HEIGHT,
} from '../../data/fundingMarketRisk'
import { SortChevron } from './icons'
import RiskRow from './RiskRow'

export default function RiskTable({
  markets,
  sortKey,
  sortDirection,
  onSort,
  favorites,
  onToggleFavorite,
}) {
  const bodyHeight = markets.length * ROW_HEIGHT
  const frameHeight = Math.min(
    HEADER_HEIGHT + bodyHeight + FOOTER_HEIGHT,
    Math.max(360, (typeof window !== 'undefined' ? window.innerHeight : 900) - 332)
  )

  return (
    <div className="max-mobile:hidden">
      <div
        className="relative size-full overflow-auto funding-risk-table-scroll"
        style={{ height: frameHeight }}
      >
        <table className="relative z-0 grid text-xs whitespace-nowrap text-ink bg-transparent">
          <thead className="sticky top-0 z-5 grid align-middle border-b-[0.5px] border-line [background:linear-gradient(var(--color-fill),var(--color-fill)),var(--color-bg)]">
            <tr className="flex w-full items-center gap-3 px-3 h-9 min-h-0">
              {COLUMNS.map((column) => {
                const active = sortKey === column.id
                return (
                  <th
                    key={column.id}
                    className="flex items-center py-1 leading-2xs font-normal whitespace-nowrap uppercase font-mono label-meta text-muted grow min-w-0"
                    role="columnheader"
                    style={{ width: column.width }}
                  >
                    <button
                      type="button"
                      className={
                        active
                          ? 'flex cursor-pointer items-center gap-1 uppercase transition-colors select-none hover:text-ink text-ink'
                          : 'flex cursor-pointer items-center gap-1 uppercase transition-colors select-none hover:text-ink'
                      }
                      onClick={() => onSort(column.id)}
                    >
                      {column.label}
                      {active ? (
                        <span
                          aria-hidden="true"
                          data-direction={sortDirection}
                          className="flex shrink-0 items-center"
                          style={
                            sortDirection === 'asc'
                              ? { transform: 'rotate(180deg)' }
                              : undefined
                          }
                        >
                          <span
                            data-icon="true"
                            className="flex shrink-0 items-center justify-center size-[8px] text-ink/70"
                          >
                            <SortChevron />
                          </span>
                        </span>
                      ) : null}
                    </button>
                  </th>
                )
              })}
            </tr>
          </thead>
          <tbody className="relative grid" style={{ height: bodyHeight }}>
            {markets.map((market, index) => (
              <RiskRow
                key={market.symbol}
                market={market}
                index={index}
                favorite={favorites.has(market.symbol)}
                onToggleFavorite={onToggleFavorite}
              />
            ))}
          </tbody>
          <tfoot>
            <tr className="flex w-full">
              <td className="w-full" colSpan={7}>
                <div aria-hidden="true" className="h-2" />
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  )
}
